import { ApiStatus, BladeBaseProps } from '../../types';

export const loanOptionDefaultAEM = {
    heading: 'What are options for your Electric Vehicle / Hybrid?',
    description: 'Based on what you have told us, here are a few options for you to consider.',
    loanAmountTypeLabel: 'Borrowing amount',
    loanAmount: [
        {
            key: 'BYD Atto 3',
            value: 50000,
        },
        {
            key: 'Tesla Model 3 Rear-Wheel',
            value: 61900,
        },
        {
            key: 'Tesla Model 3 Dual Motor All-Wheel',
            value: 71900,
        },
    ],
    loanAmountString: '$50,000.00 (for Electric Vehicle)',
    loanTermTypeLabel: 'Loan term',
    loanTerm: [
        {
            key: '1 Year',
            value: 1,
        },
        {
            key: '2 Years',
            value: 2,
        },
        {
            key: '3 Years',
            value: 3,
        },
        {
            key: '4 Years',
            value: 4,
        },
        {
            key: '5 Years',
            value: 5,
        },
        {
            key: '6 Years',
            value: 6,
        },
        {
            key: '7 Years',
            value: 7,
        },
    ],
    frequencyTypeLabel: 'Repayment frequency',
    frequency: [
        {
            key: 'Weekly',
            value: 'Weekly',
        },
        {
            key: 'Fortnightly',
            value: 'Fortnightly',
        },
        {
            key: 'Monthly',
            value: 'Monthly',
        },
    ],
    loanOptionsHeading: 'A few options for your consider',
    confirmButtonText: '{confirmButton placeholder}',
    validations: {
        hardValidations: {
            loanAmountLimit: {
                defaultErrorMessage: 'Enter loan amount',
                minValue: '1',
                minValueMessage: ' $4,000 minimum loan amount',
                maxValueMessage: ' exceed max loan amount',
                maxValueNotification: {
                    heading: 'What you intend to borrow exceeds the maximum loan amount we offer for Unsecured Loan Fixed and Variable.',
                    description: 'The estimates below are limited to our maximum loan amount. Should you wish to proceed you will need to .....',
                },
            },
            confirmButtonText: {
                defaultErrorMessage: '{confirmButtonDefaultErrorMessage}',
            },
        },
    },

};

export const loanOptionDefault = {
    isShowNotification: false,
    isShowLoanOptionTabs: false,
    isShowExceedInfo: false,
    exceedInfo: {
        header: '',
        content: '',
    },
    loanOptionFormDetail: {
        minAmount: 4000,
        maxAmount: 100000,
        loanAmount: 50000,
        loanTermYear: 7,
        repaymentFrequency: 'Weekly',
        repayments: {
            standardRate: [
                {
                    loanOptionId: 10,
                    repaymentPerWeek: 800,
                },
                {
                    loanOptionId: 11,
                    repaymentPerWeek: 900,
                },
                {
                    loanOptionId: 12,
                    repaymentPerWeek: 1000,
                },
            ],
            greenRate: [
                {
                    loanOptionId: 10,
                    repaymentPerWeek: 500,
                },
                {
                    loanOptionId: 11,
                    repaymentPerWeek: 600,
                },
                {
                    loanOptionId: 12,
                    repaymentPerWeek: 700,
                },
            ],
        },
    },
    loanOptionTabs: {
        defaultTab: 0,
        tabs: [
            {
                tabLabel: 'Standard rate',
                mappedRepaymentTable: 'standardRate',
            },
            {
                tabLabel: 'Green rate',
                mappedRepaymentTable: 'greenRate',
            },
        ],
    },
    notification: {
        heading: 'Our min borrowing amount is $4,000.',
        context: 'When your borrowing power cannot cover the amount you need, Personal Loan may not be the right product for you.',
    },
    loanOptions: [
        {
            id: 10,
            isRecommendedPrimary: false,
            isRecommendedPrimaryText: '',
            isRecommendedSecondary: false,
            isRecommendedSecondaryText: '',
            isRecommendedOffer: false,
            heading: 'Secured personal loan',
            cappedMessage: 'You can borrow up to $100,000',
            cappedAmount: 100000,
            description: 'You can typically pay a lower rate by using your current car or the car you’re buying as security',
            repayment: {
                heading: 'Estimated repayments could be',
                description: 'If you borrow $48,011.00 for 7years',
                toolTip: 'This is an estimate only',
                amount: 540,
                frequency: 'Weekly',
                bottomDescription: 'Based on a representative rate of 7.99% p.a. (Comparision rate 9.39% p.a. *)',
            },
            interestRates: {
                standardRate: {
                    heading: 'interest rate',
                    description: [
                        {
                            display: 'Interest rate after discount <strong>{0}</strong> p.a.',
                        },
                        {
                            display: 'Usually {0}-{1} p.a.(Comparison rate: {2}p.a.*)',
                        },
                    ],
                },
                greenRate: {
                    heading: 'interest rate',
                    description: [
                        {
                            display: 'Interest rate after discount <strong>{0}</strong> p.a.',
                        },
                        {
                            display: 'Usually {0}-{1} p.a.(Comparison rate: {2}p.a.*)',
                        },
                    ],
                    discount: '5% Green Loan discount applied',
                },
            },
            fees: {
                heading: 'Fees',
                description: [
                    {
                        display: 'Establishment fee $250',
                    },
                    {
                        display: 'Loan service fee $15 per month',
                    },
                    {
                        display: 'Some additional fees, including a late-payment fee and other electronic banking fees, may also apply. See more',
                    },

                ],
            },
            features: {
                heading: 'Features',
                description: [
                    {
                        display: 'Lower interest rate',
                    },
                    {
                        display: 'Repay up to $1,000 extra per year with no fee1',
                    },
                    {
                        display: 'Buy a new car or one that\'s less than 5 years old',
                    },
                    {
                        display: 'Borrow range: $4,000 to $100,000',
                    },
                ],
            },
            offer: {
                heading: 'Offer: $0 establishment fee',
                description: [
                    {
                        display: 'Limited time offer when you apply and fund by 14 September 2024.',
                    },
                ],
            },
            button: {
                buttonText: 'Learn more',
                openLink: 'https://www.commbank.com.au/',
            },
            hyperLink: {
                linkText: 'Learn More',
                openLink: 'https://www.commbank.com.au/',
            },
        },
    ],
};

export type LoanOptionAEM = typeof loanOptionDefaultAEM;
export type LoanOptionData = typeof loanOptionDefault;

export type LoanAmountType = 'InputText' | 'Select';

export interface LoanOptionBladeProps extends BladeBaseProps {
    loanAmountType: LoanAmountType;
    enableAccordionFeatures?: boolean;
}

export interface LoanOptionRepayment {
    loanOptionId: number,
    repaymentPerWeek: number,
}

export interface LoanOptionFormDetail {
    minAmount: number,
    maxAmount: number,
    loanAmount: number,
    loanTermYear: number,
    repaymentFrequency: string,
    isValidAmount?: boolean,
    repayments?: Record<string, LoanOptionRepayment[]>
}
export type LoanOptionTabInfo = {
    tabLabel: string,
    mappedRepaymentTable: string,
}
export interface LoanOptionApiEndpoints {
    updateLoanOptionFormDetailApiUrl?: string,
    getLoanOptionApiUrl: string,
}
export interface LoanOptionRequest {
    applicationNumber: string,
}

export interface LoanOptionResponse {
    content: LoanOptionAEM,
    loanOptionData: LoanOptionData,
}

export interface UpdateLoanOptionFormDetailRequest {
    loanAmount: number,
    loanTermYear: number,
}

export interface UpdateLoanOptionFormDetailResponse {
    repayments: Record<string, LoanOptionRepayment[]>
}

export interface LoanOptionState {
    content: LoanOptionAEM,
    loanOptionData: LoanOptionData,
    loanOptionFormDetail: LoanOptionFormDetail,
    updateLoanOptionFormDetailRequest: UpdateLoanOptionFormDetailRequest,
    getLoanOptionApiStatus: ApiStatus
    updateLoanOptionFormDetailApiStatus: ApiStatus
    apiEndpoints: LoanOptionApiEndpoints,
}
